import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { driver } from "driver.js";
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'vex-on-demand',
  templateUrl: './on-demand.component.html',
  styleUrls: ['./on-demand.component.scss']
})
export class OnDemandComponent implements OnInit {
  categories = [];
  subCategories = [];
  banner: any;
  activeTab: string = 'live_video';
  selectedCategory;
  categoriesPlaceholder = Array(3);

  constructor(public guiService: GuiService, private restService: RestService, public translate: TranslateService, private route: ActivatedRoute) { }

  ngOnInit() {
    sessionStorage.removeItem('selectedOndemandCategory');
    sessionStorage.removeItem('selectedOndemandVideo');
    this.guiService.showSpinner = false;
    if (this.guiService.userLogged) {
      this.getCategories();
    }else {
      this.guiService.goTo('main/home');
    }
    console.debug(this.route.snapshot.paramMap.get('tab'))
    if(this.route.snapshot.paramMap.get('tab')){
      const tab = this.route.snapshot.paramMap.get('tab');
      this.activeTab = tab;
    }
  }

  getCategories() {
    this.guiService.showSkeleton = true;
    this.restService.postService('category', '/search?ALL_LANGUAGES=true', { page: 0, size: 100 }).subscribe((ris) => {
      this.categories = [];
      this.subCategories = [];
      for (let item of ris.items) {
        if (item.name) {
          if (item.parentId) {
            this.subCategories.push(item)
          } else {
            if (item.name !== 'BANNER' && item.name !== 'SFIDA A TEMPO') {
              this.categories.push(item)
            } else if (item.name === 'BANNER') {
              this.banner = item;
            }

          }
        }
      }
      this.guiService.showSkeleton = false;
      this.openCategory(this.categories[0]);
    })
  }

  checkOnDemandEnabled() {
    if (this.guiService.userLogged.masterData.functionalityPromotions) {
      const onDemandPromoObj = this.guiService.userLogged.masterData.functionalityPromotions.find(x => x.code === 'ONDEMAND');
      if (onDemandPromoObj && onDemandPromoObj.subscriptionIds && onDemandPromoObj.subscriptionIds.includes(this.guiService.userLogged.userPaymentInfo.subscriptionId)) {
        console.debug("IL PIANO E' COMPRESO")
        const registrationDate = moment(this.guiService.userLogged.user.registrationDate).format('YYYY-MM-DD');
        const toDate = moment(onDemandPromoObj.toDate).format('YYYY-MM-DD');

        if (moment(registrationDate).isSameOrBefore(toDate)) {
          console.debug("LA REGISTRAZIONE E' PRIMA DEL TODATE")

          this.subCategories.forEach(category => {
            category.videos ?
              category.videos.forEach(video => {
                video.videoBlocked = false
              })
              : null
          })

          this.categories.forEach(category => {
            category.videos ?
              category.videos.forEach(video => {
                video.videoBlocked = false
              })
              : null
          })
        }
      }
    }
  }

  startNow(idMacro) {
    this.checkOnDemandEnabled();
    const item = this.categories.find(cat => cat.id === idMacro);
    item.subCategories = this.retriveRelativeSubCategories(item.id);
    sessionStorage.setItem('selectedOndemandCategory', JSON.stringify(item));
    this.guiService.goTo('main/ondemand-category')
  }

  videoDateCheck() {
    const tmpSubCategories = JSON.parse(JSON.stringify(this.subCategories))
    for (let k = 0; k < tmpSubCategories.length; k++) {
      let category = tmpSubCategories[k];
      if (category.videos && category.videos.length > 0) {
        for (let i = 0; i < category.videos.length; i++) {
          let video = category.videos[i]
          const publishDate = moment(video.publishDate, 'unix').format('YYYY-MM-DD');
          const expireDate = video.expirationDate ? moment(video.expirationDate, 'unix').format('YYYY-MM-DD') : null;
          const today = moment().format('YYYY-MM-DD')

          if (moment(today).isSameOrAfter(publishDate) && expireDate && moment(today).isSameOrBefore(expireDate) || moment(today).isSameOrAfter(publishDate) && !expireDate) {
            console.debug('LA DATA DI PUBBLICAZIONE E VALIDA ')
          } else {
            console.debug('NOT VALID')
            let indexSubCategory = this.subCategories.findIndex(cat => cat.id === category.id);
            let indexToRemove = this.subCategories[indexSubCategory].videos.findIndex(vid => vid.name === video.name)

            this.subCategories[indexSubCategory].videos.splice(indexToRemove, 1)
          }
        }
      } else {
        let indexToRemove = this.subCategories.findIndex(cat => cat.id === category.id)
        this.subCategories.splice(indexToRemove, 1)
      }
    }

    for (let k = 0; k < this.categories.length; k++) {
      let category = this.categories[k];
      if (category.videos && category.videos.length > 0) {
        for (let i = 0; i < category.videos.length; i++) {
          let video = category.videos[i]
          const publishDate = moment(video.publishDate, 'unix').format('YYYY-MM-DD');
          const expireDate = video.expirationDate ? moment(video.expirationDate, 'unix').format('YYYY-MM-DD') : null;
          const today = moment().format('YYYY-MM-DD')

          if (moment(today).isSameOrAfter(publishDate) && expireDate && moment(today).isSameOrBefore(expireDate) || moment(today).isSameOrAfter(publishDate) && !expireDate) {
            console.debug('LA DATA DI PUBBLICAZIONE E VALIDA ')
          } else {
            console.debug('NOT VALID')
            let indexCategory = this.categories.findIndex(cat => cat.id === category.id);
            let indexToRemove = this.categories[indexCategory].videos.findIndex(vid => vid.name === video.name)

            this.categories[indexCategory].videos.splice(indexToRemove, 1)
          }
        }
      }
    }
  }

  openCategory(item: any) {
    this.selectedCategory = null;
    setTimeout(() => {
      this.selectedCategory = item.id;
      this.videoDateCheck()
      this.checkOnDemandEnabled()
      item.subCategories = this.retriveRelativeSubCategories(item.id);
      sessionStorage.setItem('selectedOndemandCategory', JSON.stringify(item));
      setTimeout(() => {
        localStorage.getItem('tourOnDemandShowed') ? null : this.startTour();
      }, 800);
    }, 100);
  }

  retriveRelativeSubCategories(id){
    return this.subCategories.filter(x => x.parentId === id);
  }

  selecTab(tab){
    this.activeTab = tab;
    if(tab === 'live_video'){
      this.getCategories();
    }
  }

  startTour(): void {
    localStorage.setItem('tourOnDemandShowed', 'true');

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.tabs-container', popover: { title: this.translate.instant('TUTORIALS.on-demand.chooseVideoOrChallengeTitle'), description: this.translate.instant('TUTORIALS.on-demand.chooseVideoOrChallengeDescription'), side: 'bottom' } },
        { element: '.category-container', popover: { title: this.translate.instant('TUTORIALS.on-demand.exploreCategoriesTitle'), description: this.translate.instant('TUTORIALS.on-demand.exploreCategoriesDescription'), side: 'bottom' } },
        { element: '.on-demand-container', popover: { title: this.translate.instant('TUTORIALS.on-demand.browseContentTitle'), description: this.translate.instant('TUTORIALS.on-demand.browseContentDescription') } },
        { element: '.video', popover: { title: this.translate.instant('TUTORIALS.on-demand.startVideoTitle'), description: this.translate.instant('TUTORIALS.on-demand.startVideoDescription') } }
      ]
    });

    driverObj.drive();
  }

  capitalizeFirstLetter(value: string): string {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}
